import React from 'react'
import Image from "gatsby-image";
import { OutboundLink } from 'gatsby-plugin-google-analytics';

const InstaImage = (props) => (
  <OutboundLink rel="nofollow" className={`instaImage ${props.postData.type}`} href={`https://www.instagram.com/p/${props.postData.code}`} target="_blank">
    <Image alt={props.postData.text} sizes={props.postData.image.childImageSharp.sizes}/>
    <span className="postLikes">{props.postData.likes}</span>
  </OutboundLink>
)

export default InstaImage



// WEBPACK FOOTER //
// ./src/components/InstaImage.js